import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-video-home',
  templateUrl: './modal-video-home.component.html',
})
export class ModalVideoHomeComponent {
  ngbActiveModal = inject(NgbActiveModal);
  
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;

close() {
  this.videoPlayer.nativeElement.pause();
  this.videoPlayer.nativeElement.currentTime = 0;
  this.ngbActiveModal.close();
}
}
